import React, { useEffect, useCallback } from 'react';

import { useAuth } from '../../auth/AuthProvider';
import KpiCard from '../../components/KpiCard';
import Header from '../../components/Header';
import { styles, colors, radius, shadows } from '../../styles/theme';
import useCachedQuery from '../../hooks/useCachedQuery';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const getAuthHeaders = () => {
  const token = localStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const UretimDashboard = () => {
  useAuth();

  // NOT: eski /api/kesimler (lot-bazlı üretim) 2026-06-16 dead-table temizliğinde
  // kaldırıldı. Karkas parçalama da 2026-06'da kaldırıldı; üretim akışı artık reçete üretimi.
  const {
    data: özet = {},
    isLoading: ozetLoading,
    isValidating,
    revalidate: revalidateOzet
  } = useCachedQuery(
    ['dashboard', 'üretim', 'özet'],
    async () => {
      const res = await fetch(`${API_URL}/api/raporlar/özet`, { headers: getAuthHeaders() });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return await res.json();
    },
    { staleTime: 20000 }
  );

  // Auto-refresh her 30 saniye
  const refreshAll = useCallback(() => {
    revalidateOzet({ force: true }).catch(() => {});
  }, [revalidateOzet]);

  useEffect(() => {
    const interval = setInterval(refreshAll, 30000);
    return () => clearInterval(interval);
  }, [refreshAll]);

  const loading = ozetLoading;

  const stokDurumColor = özet.stok_durum === 'Kritik' ? styles.danger : özet.stok_durum === 'Dusuk' ? styles.warning : styles.info;

  return (
    <div>
      <Header title="Fabrika Panosu" />
      <div style={{ padding: '20px', background: colors.background, minHeight: 'calc(100vh - 60px)' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', minHeight: '20px' }}>
          {isValidating && !ozetLoading && (
            <span style={{ fontSize: '12px', color: colors.textSecondary, background: colors.backgroundAlt, borderRadius: '12px', padding: '4px 10px' }}>
              Güncelleniyor...
            </span>
          )}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '30px' }}>
          <KpiCard title="Ortalama Randiman" value={loading ? '...' : `%${özet.ort_randiman || 0}`} color={styles.success} icon="chart" />
          <KpiCard title="Bekleyen Transfer" value={loading ? '...' : özet.bekleyen_transfer || 0} color={styles.warning} icon="truck" />
          <KpiCard title="Stok Durumu" value={loading ? '...' : özet.stok_durum || 'Iyi'} color={stokDurumColor} icon="package" />
        </div>

        {/* Hızlı İşlemler — Card Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '12px',
          marginBottom: '24px'
        }}>
          {[
            { label: 'Parçalama Başlat', icon: '🥩', route: '/uretim#karkas-parcalama', color: '#c62828' },
            { label: 'Üretim Kaydı', icon: '🏭', route: '/uretim#uretim-kaydi', color: '#1565c0' },
            { label: 'Transfer', icon: '🚚', route: '/stok-depo#inventory', color: '#e65100' },
            { label: 'Stok Durumu', icon: '📦', route: '/stok-depo#stok-durumu', color: '#2e7d32' },
          ].map(item => (
            <div
              key={item.label}
              onClick={() => { window.location.href = item.route; }}
              style={{
                background: colors.surface, borderRadius: radius.xl, padding: '20px 16px',
                textAlign: 'center', cursor: 'pointer', borderLeft: `4px solid ${item.color}`,
                boxShadow: shadows.sm, transition: 'transform 0.15s, box-shadow 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.12)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = shadows.sm; }}
            >
              <div style={{ fontSize: '28px', marginBottom: '8px' }}>{item.icon}</div>
              <div style={{ fontSize: '14px', fontWeight: '600', color: item.color }}>{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UretimDashboard;
